<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5 mb-5">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header page-title="Unidades Administrativas"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/hierarchy.png">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/unidades', login.orgao.id]" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-2" />
      <div class="project-tab">
        <div class="form-row">
          <div class="col-md-12">
            <ul class="nav nav-tabs" id="myTab" role="tablist" style="font-size: 13px;">
              <li class="nav-item">
                <a class="nav-link active" id="principal-tab" data-toggle="tab" href="#principal" role="tab"
                  aria-controls="principal" aria-selected="true">Dados da unidade</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="executora-tab" data-toggle="tab" href="#executora" role="tab"
                  aria-controls="executora" aria-selected="true">Unidades Executoras</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="membro-tab" data-toggle="tab" href="#membro" role="tab" aria-controls="membro"
                  aria-selected="true">Membros</a>
              </li>
            </ul>
            <div class="tab-content pt-3" id="myTabContent">
              <div class="tab-pane fade show active" id="principal" role="tabpanel" aria-labelledby="principal-tab">
                <div class="form-row">
                  <lib-divisor altura="250px" imagem="assets/img/real-estate.png"></lib-divisor>
                  <div class="col-md-11 col-lg-11 col-xl-11">
                    <div class="form-row">
                      <div class="form-group col-md-2">
                        <label for="codigou">Código<span class="text-danger">*</span></label>
                        <input #codigo id="codigou" unmask="true" [imask]="{mask: '00.00.00'}" formControlName="codigo"
                          type="text" class="form-control font-weight-bold"
                          [ngClass]="{ 'is-invalid': submitted && f.codigo.errors }">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-9">
                        <label for="nomeu">Nome<span class="text-danger">*</span></label>
                        <input id="nomeu" formControlName="nome" class="form-control font-weight-bold"
                          [ngClass]="{ 'is-invalid': submitted && f.nome.errors }">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="tribunalu">N˚ TCE<span class="text-danger">*</span></label>
                        <input id="tribunalu" formControlName="tribunal" type="text"
                          class="form-control font-weight-bold"
                          [ngClass]="{ 'is-invalid': submitted && f.tribunal.errors }">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-4">
                        <label for="ato">Ato jurídico<span class="text-danger">*</span></label>
                        <select id="ato" formControlName="ato" class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.ato.errors }">
                          <option [ngValue]="item.id" *ngFor="let item of listaAtos">
                            {{item.nome}}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-3">
                        <label for="telefone">Telefone</label>
                        <input [imask]="{mask: [ {mask: '0000-0000'}, {mask: '00000-0000'}, {mask: '(00) 0000-0000'}, {mask: '(00) 00000-0000'} ]}" unmask="true"
                          formControlName="telefone" type="text" class="form-control" id="telefone">
                      </div>
                    </div>
                  </div>
                </div>
                <br>
                <div class="form-row">
                  <lib-divisor altura="150px" imagem="assets/img/boss.png"></lib-divisor>
                  <div class="col-md-11 col-lg-11 col-xl-11">
                    <div class="form-row">
                      <div class="form-group col-md-8">
                        <label for="responsavel">Responsável<span class="text-danger">*</span></label>
                        <input id="responsavel" formControlName="responsavel" class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.responsavel.errors }">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-5">
                        <label for="cargo">Cargo<span class="text-danger">*</span></label>
                        <input id="cargo" formControlName="cargo" class="form-control"
                          [ngClass]="{ 'is-invalid': submitted && f.cargo.errors }">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="cpf">CPF<span class="text-danger">*</span></label>
                        <input id="cpf" formControlName="cpf" unmask="true" [imask]="{mask: '000.000.000-00'}"
                          class="form-control" [ngClass]="{ 'is-invalid': submitted && f.cpf.errors }">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row">
                  <lib-divisor altura="150px" imagem="assets/img/worker.png"></lib-divisor>
                  <div class="col-md-5 col-lg-5 col-xl-5">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <label for="ordenador">Ordenador da despesa</label>
                            <input id="ordenador" formControlName="ordenador" class="form-control">
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group col-md-12">
                            <label for="cargo_ordenador">Cargo</label>
                            <input id="cargo_ordenador" formControlName="cargo_ordenador" class="form-control">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="offset-1 col-md-5 col-lg-5 col-xl-5">
                    <div class="col-12">
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="tesoureiro">Tesoureiro</label>
                          <input id="tesoureiro" formControlName="tesoureiro" class="form-control">
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-group col-md-12">
                          <label for="cargo_tesoureiro">Cargo</label>
                          <input id="cargo_tesoureiro" formControlName="cargo_tesoureiro" class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="executora" role="tabpanel" aria-labelledby="executora-tab">
                <div class="form-row" *ngIf="entidadeForm.get('codigo')?.value">
                  <div class="col-12">
                    <lib-executora-form [(lista)]="listaExecutoras" [(entidade)]="entidade" [login]="login"
                      (preencherTabela)="updateExecutora($event)" [codigounidade]="entidadeForm.get('codigo').value">
                    </lib-executora-form>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="membro" role="tabpanel" aria-labelledby="membro-tab">
                <lib-unidade-membro [(lista)]="listaMembros" [(entidade)]="entidade" [login]="login">
                </lib-unidade-membro>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>